// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SearchAccountResponseModel } from './searchAccountResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class HubV1HubV1SearchAccountsDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': Array<SearchAccountResponseModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof HubV1HubV1SearchAccountsDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<SearchAccountResponseModel>"
        },
    ];

    static getAttributeTypeMap() {
        return HubV1HubV1SearchAccountsDefaultResponse.attributeTypeMap;
    }
}
